// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var p$prime = /* #__PURE__ */ Concur_React_DOM["p$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var hiddenSelectLabel = function (state) {
    var label = Data_Maybe.fromMaybe(Translate.lookupTranslation("none"))(map(function (v) {
        return v.label;
    })(Widgets_BetterSelect.selectedItem(state)));
    return div([ Concur_React_Props.className("hidden-select") ])([ p$prime([ text(label) ]) ]);
};
var hiddenSelectDisabled = function (state) {
    var label = Data_Maybe.fromMaybe(Translate.lookupTranslation("none"))(map(function (v) {
        return v.label;
    })(Widgets_BetterSelect.selectedItem(state)));
    return div([ Concur_React_Props.className("hidden-select") ])([ p$prime([ text(label) ]), button([ Concur_React_Props.className("hidden-select-edit-button"), Concur_React_Props.disabled(true), Concur_React_Props["_type"]("button") ])([ text(Translate.lookupTranslation("edit")) ]) ]);
};
var hiddenSelect = function (state) {
    var label = Data_Maybe.fromMaybe(Translate.lookupTranslation("none"))(map(function (v) {
        return v.label;
    })(Widgets_BetterSelect.selectedItem(state)));
    return bind(div([ Concur_React_Props.className("hidden-select") ])([ p$prime([ text(label) ]), button([ Concur_React_Props.className("hidden-select-edit-button"), Concur_React_Props.onClick ])([ text(Translate.lookupTranslation("edit")) ]) ]))(function () {
        return Widgets_BetterSelect.selectWidget(state);
    });
};
export {
    hiddenSelect,
    hiddenSelectLabel,
    hiddenSelectDisabled
};
//# sourceMappingURL=index.js.map
